/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'

import PlayStore from '../../static/icons/ic-play-store.webp'
import AppsStore from '../../static/icons/ic-apps-store.webp'
import { TextBodyOne } from '../text'
import { Style } from './index.styles'

const CardDownload = ({
  contentImage,
  backgroundImage,
  title,
  desc,
  tag,
  boxShadow,
  border
}) => {
  return (
    <Style boxShadow={boxShadow} border={border}>
      <img src={backgroundImage} alt="halojasa/background-image" />
      <Grid>
        <Row className="end">
          <Col sm={12} xs={12} md={12} lg={5}>
            <img className="image" src={contentImage} alt="halojasa/content-image" />
          </Col>
          <Col sm={12} xs={12} md={12} lg={7}>
            <div className="card">
              <div className="title">{title}</div>
              <div className="tag">{tag}</div>
              <TextBodyOne display="block" align="left">
                {desc}
              </TextBodyOne>
              <div style={{ paddingTop: '50px' }}>
                <b>Klik Untuk Download Aplikasi</b>
                <div className="link-apps">
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=halo.jasa.startup"
                    className="smaller-hover android-store"
                  >
                    <img src={PlayStore} alt="halojasa/playstore" />
                  </a>
                  <a
                    target="_blank"
                    href="https://apps.apple.com/app/apple-store/id1492671277?pt=119003762&ct=website%20halo%20jasa&mt=8"
                    className="smaller-hover ios-store"
                  >
                    <img src={AppsStore} alt="halojasa/appstore" />
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default CardDownload
